import React, { useRef, useState } from 'react';
import {
  View,
  Pressable,
  LayoutChangeEvent,
  GestureResponderEvent,
} from 'react-native';

export default function MusicProgressBar({
  progress,
  color,
  onSeek,
}: {
  progress: number;
  color: string;
  onSeek: (fraction: number) => void;
}) {
  const trackRef = useRef<View>(null);
  const [width, setWidth] = useState(0);

  const handleLayout = (event: LayoutChangeEvent) => {
    setWidth(event.nativeEvent.layout.width);
  };

  const handlePress = (event: GestureResponderEvent) => {
    // `locationX` on react-native-web mouse events has proven unreliable in
    // this codebase's RN-web version, so this measures the track's actual
    // page position and uses the raw pointer `pageX` instead.
    const pageX = (event.nativeEvent as unknown as { pageX?: number }).pageX;
    if (!width || typeof pageX !== 'number' || !trackRef.current) {
      return;
    }

    trackRef.current.measure((x, y, measuredWidth, height, pageXOffset) => {
      const effectiveWidth = measuredWidth || width;
      const fraction = Math.min(
        Math.max((pageX - pageXOffset) / effectiveWidth, 0),
        1,
      );
      onSeek(fraction);
    });
  };

  return (
    <Pressable
      onPress={handlePress}
      style={{
        justifyContent: 'center',
        paddingVertical: 6,
        // @ts-expect-error `cursor` is a web-only style property
        cursor: 'pointer',
      }}
    >
      <View
        ref={trackRef}
        onLayout={handleLayout}
        style={{
          height: 4,
          borderRadius: 2,
          backgroundColor: 'rgba(128,128,128,0.25)',
          overflow: 'hidden',
        }}
      >
        <View
          style={{
            height: 4,
            width: `${Math.min(Math.max(progress, 0), 1) * 100}%`,
            backgroundColor: color,
          }}
        />
      </View>
    </Pressable>
  );
}
